import {ModuleComponent} from "../../js/module-component";

/**
 * Hero "Agentes IA" (SEION).
 *  - Máquina de escribir + rotación de 4 canales en la tarjeta de chat.
 *  - Contadores animados de las chips de métrica.
 *  Portado del handoff de diseño. Respeta prefers-reduced-motion.
 */
export class ModAgentsOne extends ModuleComponent{

    ready(){
        super.ready();

        this.el = this.$root.get(0);
        if(!this.el) return;

        this.cssScope = "web-mod-agents-one";
        this.typingSpeed = 2;                 // caracteres por tick (1-6)
        this.tickMs = 32;
        this.pauseTicks = 34;                 // pausa entre mensajes de un canal (~1.1s)
        this.endPauseTicks = 110;             // pausa de lectura al terminar el canal (~3.5s)

        this.channels = [
            {
                label: "WhatsApp Center",
                agent: "Agente de Atención al Cliente",
                hint: "Cliente escribiendo desde WhatsApp Business…",
                script: [
                    {role: "user",   text: "Hola, quiero cambiar mi cita del jueves."},
                    {role: "agent",  text: "Te identifico por tu número: cita del jueves 12:30 en Llongueras Serrano. ¿Te reagendo al viernes 11:00?"},
                    {role: "user",   text: "Perfecto, el viernes."},
                    {role: "action", text: "Cita actualizada en el sistema · confirmación enviada"}
                ]
            },
            {
                label: "Dirección y Operaciones",
                agent: "Agente de Datos y Reporting",
                hint: "Pregunta a tu empresa, sin pedir un informe…",
                script: [
                    {role: "user",   text: "¿Cómo va la productividad por zona este mes?"},
                    {role: "agent",  text: "Levante +14 % y Centro −6 %. La caída viene de 38 incidencias abiertas sin asignar en Madrid."},
                    {role: "action", text: "Gráfica generada desde ERP + CRM en 4 s"}
                ]
            },
            {
                label: "Agente de voz",
                agent: "Agente de IA por voz · Servicio técnico",
                hint: "Llamada entrante atendida en cualquier idioma…",
                script: [
                    {role: "user",   text: "Mi máquina de exprimido da error E-04."},
                    {role: "agent",  text: "Es un atasco en el canal de alimentación. Le guío en 3 pasos y, si sigue, abro ticket con un técnico."},
                    {role: "action", text: "Ticket 4471 creado · sin pasar por centralita"}
                ]
            },
            {
                label: "Leads y Marketing",
                agent: "Agente de Marketing y Leads",
                hint: "Clasificando leads mientras duermes…",
                script: [
                    {role: "user",   text: "Nueva solicitud desde el formulario web."},
                    {role: "agent",  text: "Lead cualificado como industrial >100 empleados. Asignado a Ana, con resumen y siguiente acción propuesta."},
                    {role: "action", text: "9 500 leads asignados automáticamente"}
                ]
            }
        ];

        //Textos traducidos inyectados desde el Twig (para /en/). Si existen,
        //sustituyen a las cadenas por defecto de arriba; si no, se usan estas.
        const dataEl = this.el.querySelector(".js-agents-one-data");
        if(dataEl){
            try {
                const parsed = JSON.parse(dataEl.textContent);
                if(Array.isArray(parsed) && parsed.length) this.channels = parsed;
            } catch(e){ /* fallback a las cadenas por defecto */ }
        }

        this.msgsEl = this.el.querySelector(".js-chat-msgs");
        this.agentNameEl = this.el.querySelector(".js-agent-name");
        this.hintEl = this.el.querySelector(".js-input-hint");
        this.tabsEl = this.el.querySelector(".js-tabs");
        this.statHoursEl = this.el.querySelector(".js-stat-hours");
        this.statSpeedEl = this.el.querySelector(".js-stat-speed");

        this.reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

        this.startCounters();

        if(this.reduceMotion) return; // deja el estado estático del Twig

        // Estado inicial de la máquina de escribir.
        this.ch = 0; this.mi = 0; this.chars = 0; this.pause = 0;
        this.renderedCh = -1;
        this.els = [];

        this.timer = setInterval(() => this.tick(), this.tickMs);
    }

    // -- Contadores de las chips (0 -> valor final en 1800ms) -----------------
    startCounters(){
        if(!this.statHoursEl && !this.statSpeedEl) return;
        if(this.reduceMotion){
            if(this.statHoursEl) this.statHoursEl.textContent = "830";
            if(this.statSpeedEl) this.statSpeedEl.textContent = "90";
            return;
        }
        const t0 = Date.now();
        this.counter = setInterval(() => {
            const p = Math.min(1, (Date.now() - t0) / 1800);
            const e = 1 - Math.pow(1 - p, 3);
            if(this.statHoursEl) this.statHoursEl.textContent = String(Math.round(830 * e));
            if(this.statSpeedEl) this.statSpeedEl.textContent = String(Math.round(90 * e));
            if(p >= 1) clearInterval(this.counter);
        }, 40);
    }

    // -- Reducer (idéntico al prototipo) + reconciliación del DOM -------------
    tick(){
        const speed = Math.max(1, Math.round(this.typingSpeed));
        const script = this.channels[this.ch].script;
        const msg = script[this.mi];

        const isLast = this.mi >= script.length - 1;
        // Al terminar el canal se aguanta más para dar tiempo a leer todo el hilo.
        const wait = isLast ? this.endPauseTicks : this.pauseTicks;

        if(this.chars < msg.text.length){
            this.chars = Math.min(msg.text.length, this.chars + speed);
        }else if(this.pause < wait){
            this.pause += 1;
        }else if(!isLast){
            this.mi += 1; this.chars = 0; this.pause = 0;
        }else{
            this.ch = (this.ch + 1) % this.channels.length;
            this.mi = 0; this.chars = 0; this.pause = 0;
        }

        this.sync();
    }

    sync(){
        const channel = this.channels[this.ch];

        // Cambio de canal: reconstruye cabecera, tabs y limpia mensajes.
        if(this.renderedCh !== this.ch){
            this.renderedCh = this.ch;
            if(this.agentNameEl) this.agentNameEl.textContent = channel.agent;
            if(this.hintEl) this.hintEl.textContent = channel.hint;
            if(this.tabsEl){
                const tabs = this.tabsEl.children;
                for(let i = 0; i < tabs.length; i++){
                    tabs[i].classList.toggle("is-active", i === this.ch);
                }
                // En pantallas estrechas la tira de pestañas se desplaza en
                // horizontal, así que el canal activo puede quedar fuera de
                // vista. Se mueve el scroll de la tira, no el de la página.
                const active = tabs[this.ch];
                if(active && this.tabsEl.scrollWidth > this.tabsEl.clientWidth){
                    const delta = active.getBoundingClientRect().left - this.tabsEl.getBoundingClientRect().left;
                    this.tabsEl.scrollTo({left: Math.max(0, this.tabsEl.scrollLeft + delta - 16), behavior: "smooth"});
                }
            }
            if(this.msgsEl) this.msgsEl.innerHTML = "";
            this.els = [];
        }

        // Añade elementos para los mensajes que aún no existen (0..mi).
        while(this.els.length <= this.mi){
            const idx = this.els.length;
            const m = channel.script[idx];
            const isCurrent = idx === this.mi;
            const text = isCurrent ? m.text.slice(0, this.chars) : m.text;
            const typing = isCurrent && this.chars < m.text.length;
            const node = this.buildMsg(m, text, typing);
            this.msgsEl.appendChild(node);
            this.els.push(node);
        }

        // Actualiza el mensaje en curso (texto parcial + caret).
        const cur = channel.script[this.mi];
        const curEl = this.els[this.mi];
        if(curEl){
            const typing = this.chars < cur.text.length;
            this.setMsgText(curEl, cur, cur.text.slice(0, this.chars), typing);
        }
    }

    buildMsg(m, text, typing){
        const s = this.cssScope;
        const el = document.createElement("div");
        if(m.role === "user"){
            el.className = `${s}__msg ${s}__msg--user`;
            el.textContent = text;
        }else if(m.role === "agent"){
            el.className = `${s}__msg ${s}__msg--agent`;
            this.setMsgText(el, m, text, typing);
        }else{
            el.className = `${s}__msg ${s}__msg--action`;
            const dot = document.createElement("span");
            dot.className = `${s}__action-dot`;
            el.appendChild(dot);
            el.appendChild(document.createTextNode(text));
        }
        return el;
    }

    setMsgText(el, m, text, typing){
        const s = this.cssScope;
        if(m.role === "agent"){
            el.textContent = text;
            if(typing){
                const caret = document.createElement("span");
                caret.className = `${s}__caret`;
                el.appendChild(caret);
            }
        }else if(m.role === "user"){
            el.textContent = text;
        }else{
            // action: mantiene el dot y actualiza sólo el texto final.
            el.textContent = "";
            const dot = document.createElement("span");
            dot.className = `${s}__action-dot`;
            el.appendChild(dot);
            el.appendChild(document.createTextNode(text));
        }
    }

    destroy(){
        if(this.timer) clearInterval(this.timer);
        if(this.counter) clearInterval(this.counter);
        if(super.destroy) super.destroy();
    }
}
